export class BookmarkGroupModel {
  group_id: number;
  group_name?: string;
  member_edit?: boolean;
  visible?: boolean;
  remove?: boolean;
}
